import { z } from "zod";
import { computeMinutesFromHours } from "../../../../../common/utils/cargaHorariaUtils";

/**
 * TreinamentoSchema
 */

export const TreinamentoSchema = z.object({
  ativo: z.coerce.number(),
  nome: z.string(),
  versao: z.string(),
  cargaHoraria: z.string().default('').transform(x => computeMinutesFromHours(x)),
  conteudoProgramatico: z.string().nullable().default(null),
});

/**
 * TreinamentoForm
 */

export type TreinamentoForm = z.infer<typeof TreinamentoSchema>;

/**
 * Default value
 */

export const defaultTreinamentoForm: Partial<TreinamentoForm> = {
  ativo: 1,
}